/* eslint-disable */
type Predicate<T> = (value: T) => boolean;

type FilterObject<T> = (
  obj: Record<string, T>,
  predicate: Predicate<T>
) => Record<string, T>;

export const filterObject: FilterObject<any> = (obj, predicate) => {
  return Object.keys(obj)
    .filter((key) => predicate(obj[key]))
    .reduce((res, key) => {
      res[key] = obj[key];
      return res;
    }, {} as Record<string, any>);
};

export function getColorCssValue(color: string) {
    return `rgba(var(--v-theme-${color}))`;
}
